module.exports = __webpack_public_path__ + "frontend/images/gold/bg/overlay.png?3f73acdf1bd5b1bad3d92d8b8c7ef9a0";